import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children, allowAuthenticatedPaths = [] }) => {
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isAllowedAuthenticatedPath = allowAuthenticatedPaths.some((path) =>
        location.pathname.startsWith(path)
    );

    useEffect(() => {
        if (isLoggedIn && !isAllowedAuthenticatedPath) {
            navigate(DASHBOARD_PATH, { replace: true });
        }
    }, [isLoggedIn, isAllowedAuthenticatedPath, navigate]);

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node,
    allowAuthenticatedPaths: PropTypes.arrayOf(PropTypes.string)
};

export default GuestGuard;
